import React, { Component } from 'react';
import $ from 'jquery';
import Vas from '../../Vas';
import CustomerModel from '../../models/Customer';
import '../../css/CustomerCard.css';
import { PagingTable } from 'component-lib';
import { DocumentsModel, RequestAjaxClass } from 'models-lib';

class DocumentDownload extends Component
{
    constructor(props)
    {
        super(props);
        this.state = new CustomerModel([this]);
        this.state.CurrentView = "CustomerData";
        this.state.DocumentList=[];
        this.CustomerId = localStorage.getItem('vas_customerId');
        this.state.Upload=false;
        this.state.Limit = 10;
        this.state.Start = 0;
        this.DocumentModel = new DocumentsModel([this]);
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
    }

    componentWillMount(){
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setAuth(true);
      this.Request.setErrorHandler(()=>{
        $("#LoadingIcon").removeClass().addClass('hide');
      });
      this.DocumentModel.SetRequest(this.Request);
    }

    componentDidMount(){
        $("#HeaderTitle").html(Vas.Resources.Labels["Forms"]);
    }

    Update(observer)
    {
      let me = this;
        this.setState({},()=>{
          if(observer === "GlobalDocuments"){
            let documents = [];
                     
            this.DocumentModel.Documents.forEach(function(value) {
                let document = {};
                document.Id = value.Id;
                document.FileName = value.FileName;
                document.FileSize = value.FileSize;
                documents.push(document);
            });
            
            if (me.refs.table){
              me.refs.table.setState({ Data: documents, Count: this.DocumentModel.Count, Limit: this.DocumentModel.Limit, Start: this.DocumentModel.Start, End: this.DocumentModel.Start+documents.length });
            }
            me.setState({ Count:this.DocumentModel.Count });
            $("#LoadingIcon").removeClass().addClass('hide');
        
          }
        });
    }

    load(sendData){
        this.DocumentModel.GetGlobalDocumentsByCustomerId(this.CustomerId,sendData);
    }

    render()
    {
        let searchParamsStrings = [];
        searchParamsStrings.push({ TableColumn: "customerId", SearchValue: localStorage.getItem('vas_customerId') });
        return (
          <div className={"form"} >
            <table style={{ width: '600px' }} >
              <tbody>
                <tr>
                  <td>
                    <PagingTable 
                    ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                      ref="table" 
                      SearchParamsStrings={searchParamsStrings} 
                      TableReference={this} 
                      DataBaseTable={"DokumenteZusatz"} 
                      Selectable={false} 
                      Limit={this.state.Limit} 
                      Start={this.state.Start} 
                      End={this.state.End} 
                      Count={this.state.Count} 
                      Columns={[Vas.Resources.Labels["DocumentName"],Vas.Resources.Labels["Size"],Vas.Resources.Labels["Action"]]}
                      Keys={["FileName","FileSize"]} 
                      Data={this.state.Data}
                      Download={true}
                      DownloadType={"Document"} 
                      Modus={"DBBus"}
                      Add={false} 
                      Border={false}
                      LabelPage={Vas.Resources.Labels["Page"]} 
                      LabelOf={Vas.Resources.Labels["Of"]} 
                      LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
                      AppURL={Vas.ApplicationUrl} 
                      ApiURL={Vas.ApiUrl} 
                      ApiKey={Vas.ApiKey}
                      Token={localStorage.getItem('vas_token')}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
    }
}
export default DocumentDownload;
